import { fork, take, call, put } from 'redux-saga/effects'
import { providerListRes,providerCoursesListRes,providerVideosListRes, providerCategoryListRes, providerDetailsRes, providerCoachingRes, coachingDetailResponse, getGlobalSearchPartnersResponse, getGlobalSearchCoachingResponse, coachingListingRes } from './actions'
import types from './types'
import {provider, ProviderCategory, ProviderDetail, ProviderVideoCategories, ProviderCoaching} from "../../api/provider";
import { apiDirect, postAPIWithoutModule } from "../../api/generic";

export function* doProviderListFetch() {
    while (true) {
      const { payload } = yield take(types.PROVIDERS_LIST)
      const response = yield call(postAPIWithoutModule, payload)
      yield put(providerListRes(response))
    }
  }

  // export function* doProviderCourseListFetch() {
  //   while (true) {
  //     const { payload } = yield take(types.PROVIDER_COURSES_LIST)
  //     const response = yield call(ProviderCategory, payload)
  //     console.log("courses response in saga",response);
  //     yield put(providerCoursesListRes(response))
  //   }
  // }

  export function* doProviderVideoListFetch() {
    while (true) {
      const { payload } = yield take(types.PROVIDER_VIDEOS_LIST)
      const response = yield call(ProviderVideoCategories, payload)
      console.log("videos response in saga",response);
      yield put(providerVideosListRes(response))
    }
  }

  export function* doProviderCategoryListFetch() {
    while (true) {
      const { payload } = yield take(types.PROVIDER_CATEGORY_LIST)
      const response = yield call(ProviderCategory, payload)
      console.log("provider category response in saga",response);
      yield put(providerCategoryListRes(response))
    }
  }

  export function* doProviderDetailsFetch() {
    while (true) {
      const { payload } = yield take(types.PROVIDER_DETAIL)
      const response = yield call(postAPIWithoutModule, payload)
      yield put(providerDetailsRes(response))
    }
  }

  export function* doProviderCoachingFetch() {
    while (true) {
      const { payload } = yield take(types.PROVIDER_COACHING)
      const response = yield call(ProviderCoaching, payload)
      console.log("provider coaching response in saga",response);
      yield put(providerCoachingRes(response))
    }
  }

  export function* doGetCoachingDetail() {
    while (true) {
      const { payload } = yield take(types.COACHING_DETAIL)
      const response = yield call(postAPIWithoutModule, payload)
      yield put(coachingDetailResponse(response))
    }
  }

  export function* doGetGlobalSearchPartners() {
    while (true) {
      const { payload } = yield take(types.GLOBAL_SEARCH_PARTNERS)
      const response = yield call(postAPIWithoutModule, payload)
      yield put(getGlobalSearchPartnersResponse(response))
    }
  }

  export function* doGetGlobalSearchCoaching() {
    while (true) {
      const { payload } = yield take(types.GLOBAL_SEARCH_COACHING)
      const response = yield call(postAPIWithoutModule, payload)
      yield put(getGlobalSearchCoachingResponse(response))
    }
  }

  function* auth() {
   yield fork(doProviderListFetch)
   yield fork(doProviderCategoryListFetch)
   yield fork(doProviderDetailsFetch)
   yield fork(doProviderCoachingFetch)
   yield fork(doGetCoachingDetail)
   yield fork(doGetGlobalSearchPartners)
   yield fork(doGetGlobalSearchCoaching)   
   //yield fork(doProviderVideoListFetch)
  }

export default auth